module.exports = __webpack_public_path__ + "assets/img/mail.4b1e0350.svg";